var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect } from 'react';
import { eventTracker } from './event-tracker.helper';
import { getTypedTrackCustom } from './custom-event.helper';
import { baseCustomEventSchemas } from '../constants/schemas/base-custom-event-schemas.constant';
var trackerInstance;
function getTracker() {
    if (!trackerInstance) {
        trackerInstance = eventTracker();
    }
    return trackerInstance;
}
export function getEventTracker(customEventSchemas) {
    if (customEventSchemas === void 0) { customEventSchemas = {}; }
    var trackClick = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (trackerInstance)
            trackerInstance.trackClick.apply(trackerInstance, args);
    };
    var trackCustom = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (trackerInstance)
            trackerInstance.trackCustom.apply(trackerInstance, args);
    };
    var eventSchemas = __assign(__assign({}, customEventSchemas), baseCustomEventSchemas);
    var trackCustomWrapper = getTypedTrackCustom(eventSchemas, trackCustom);
    function useEvents() {
        var listenerCleanUp = getTracker().listenerCleanUp;
        useEffect(function () {
            return function () { return listenerCleanUp.forEach(function (cleanup) { return cleanup(); }); };
        }, []);
    }
    return {
        useEvents: useEvents,
        trackClick: trackClick,
        trackCustom: trackCustomWrapper,
    };
}
